import { AppStartScreen } from './shell/AppStartScreen';
import { useState } from 'react';
import { DataImporter } from '../components/DataImporter';
import { ImportMapContext, type ImportMapInteraction } from '../components/ImportMapContext';
import { ProjectTopBar } from './shell/ProjectTopBar';
import { WorkspaceShell } from './shell/WorkspaceShell';
import { useAppStore } from './state/useAppStore';

export function AppShell() {
  const mode = useAppStore((state) => state.mode);
  const [interaction, setInteraction] = useState<ImportMapInteraction | null>(null);

  return (
    <ImportMapContext.Provider value={{ interaction, setInteraction }}>
      <div className="app-shell">
        <ProjectTopBar />
        {mode === 'empty' && !interaction ? (
          <AppStartScreen />
        ) : (
          <WorkspaceShell mode={mode === 'empty' ? 'editor' : mode} />
        )}
        <DataImporter
          variant={mode === 'empty' && !interaction ? 'start' : 'panel'}
          portalActions
        />
      </div>
    </ImportMapContext.Provider>
  );
}
